import React, { useState, useEffect } from 'react';
import Image from 'next/image';
import { landTemplates } from './landTemplate';
import { NFT, typeIdLand } from './nft-types';
import { districtsID } from 'util/constants';
import styles from './nft-assets-card.module.css';
import { SIDE_MENU_EVENTS } from '@src/components/menu/sideMenu';

type Props = {
  nft: NFT['land'];
  callback: Function;
};

const LandNFTCard: React.FC<Props> = (props) => {
  const { nft, callback } = props;
  const [previewUrl, setPreviewUrl] = useState('');
  const [error, setError] = useState(false);
  const [district, setDistrict] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const district = districtsID[nft.metadata?.districtId as string];

    if (!district) {
      setError(true);
    } else {
      setDistrict(district);
      const typeId = nft.typeID as string;
      const url =
        landTemplates[district].parcels[Number(typeId) - 1].previewURL;
      setPreviewUrl(url);
    }
    setLoading(false);
  }, [nft]);

  const loadAsset = () => {
    const typeId = nft.typeID as string;
    const url = landTemplates[district].parcels[Number(typeId) - 1].baseURL;

    callback('land_template', url, SIDE_MENU_EVENTS.SCENES, previewUrl);
  };

  if (error || loading) {
    return <></>;
  }

  return (
    <div>
      <div className={styles.card} onClick={loadAsset}>
        <Image
          className={styles.previewImage}
          src={previewUrl}
          width={240}
          height={200}
          alt={'NFT image'}
        />
        <span className={styles.name}>
          {nft.metadata?.districtName} {typeIdLand[nft.typeID as string]}
        </span>
      </div>
    </div>
  );
};

export default LandNFTCard;
